import { Card, CardContent, Container } from "@mui/material";
import { API, graphqlOperation } from "aws-amplify";
import React from "react";
import { listJobRequestComments } from "../graphql/queries";
import getUserProfile from "../utils/getUserProfile";

export default function ShownInterest() {
  const [userProfile, setUserProfile] = React.useState(null);
  const [jobRequestComments, setJobRequestComments] = React.useState([]);

  const once = [];
  React.useEffect(() => {
    getUserProfile().then((u) => {
      //

      const obj = {
        filter: { userId: { eq: u.id } },
      };
      const promise = API.graphql(
        graphqlOperation(listJobRequestComments, obj)
      );

      promise.then((d) => {
        const data = d.data.listJobRequestComments.items;
        setUserProfile(u);
        setJobRequestComments(data);
      });
    });
  }, once);

  if (userProfile === null) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <h1>Du har visat intresse för ({jobRequestComments.length}) jobb</h1>
      <h2>Work in progress</h2>
      {jobRequestComments.map(function (interest) {
        return (
          <>
            <Card style={{ background: "white", marginTop: "30px" }}>
              <CardContent>
                {interest.message}
              </CardContent>
            </Card>
          </>
        );
      })}
    </Container>
  );
}
